<script>
  import type { ITableCell, ITablePanel } from "./Table.svelte";
  import { addThemeClass } from "../../../core";

  export let data: ITablePanel;

  const cells: ITableCell[][] = data.table.useFirstRowAsHeader
    ? data.table.cells.slice(1)
    : data.table.cells;

  const header: ITableCell[] = data.table.useFirstRowAsHeader
    ? data.table.cells[0].slice(1)
    : [];

  const firstColumn = cells.map((row) => row[0]);
</script>

<div role="table" class="table" use:addThemeClass={data}>
  {#each firstColumn as cell, index}
    <div role="row" class="row">
      <div role="cell" class="column first-column">
        {@html cell.value}
        <slot {cell} />
      </div>

      <div role="cell" class="info">
        {#each cells[index].slice(1) as cell, i}
          <div class="info-row">
            {#if header && header[i]}
              <div class="info-cell header-cell">
                {@html header[i].value}
              </div>
            {/if}
            <div class="info-cell">
              {@html cell.value}
            </div>
          </div>
        {/each}
      </div>
    </div>
  {/each}
</div>

<style lang="scss">
  .table {
    border-top: 1px solid $text-color;
    border-bottom: 1px solid $text-color;
  }

  .row {
    @include small;
    line-height: 1.54;
    display: flex;

    &:first-child {
      .column,
      .info {
        border: 0;
      }
    }
  }

  .column {
    flex: 1;
    padding: 12px 15px;
    border-top: 1px solid $text-color;
  }

  .info {
    flex: 2;
    display: table;
    padding: 12px 15px;
    border-top: 1px solid $text-color;
  }

  .info-row {
    display: table-row;
  }

  .info-cell {
    display: table-cell;
    width: 50%;
    &:not(:first-child) {
      padding-left: 15px;
    }
  }
  .header-cell {
    font-weight: 900;
  }

  // Theming
  .first-column {
    font-weight: 900;
    background-color: var(--background-color);
    color: var(--text-color);
    border-color: var(--text-color);
  }

  :global(.table.default-theme) {
    .column {
      padding: 12px 0;
    }
  }
</style>
